import Breadcrumbs, {
  type BreadcrumbsProps,
} from "components/Layout/Breadcrumbs";
import BlockSpinner from "components/Spinners/BlockSpinner";
import { PageHeadingBlock } from "components/Theme/heading";
import useSetPageTitle, { type SetTitleFunction } from "hooks/setPageTitle";
import type React from "react";

interface Props extends Partial<BreadcrumbsProps> {
  headerTitle: string;
  children?: any;
  loading?: boolean;
  "data-cy"?: string;
  setPageTitle?: SetTitleFunction;
  headerActions?: React.ReactNode;
}

export function OneCardPage(props: Props): React.ReactElement {
  useSetPageTitle({ setPageTitle: props.setPageTitle });
  return (
    <div>
      {props.breadcrumbs && (
        <Breadcrumbs
          breadcrumbs={props.breadcrumbs}
          showSchemeInBreadcrumbs={props.showSchemeInBreadcrumbs}
          showCompanyInBreadcrumbs={props.showCompanyInBreadcrumbs}
        />
      )}
      <PageHeadingBlock className={"pb-4"} actions={props.headerActions}>
        {props.headerTitle}
      </PageHeadingBlock>
      <div data-cy={props["data-cy"]}>
        <BlockSpinner loading={props.loading || false}>
          {props.children}
        </BlockSpinner>
      </div>
    </div>
  );
}
